import { DestroyRef, inject, Injectable } from '@angular/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { GroupTag, GroupTagClass } from '@sleipai/sleip-models';
import {
  collection,
  collectionSnapshots,
  doc,
  Firestore,
} from '@angular/fire/firestore';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class GroupTagService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  fetchGroupTagsForUserGroup(groupId: string): Observable<GroupTag[]> {
    if (!groupId) throw new TypeError('GroupId is not a valid value');
    const userGroupRef = doc(this.firestore, `groups/${groupId}`);
    const groupTagsSubCollectionRef = collection(userGroupRef, 'groupTags');

    const groupTagsDocData$ = collectionSnapshots(groupTagsSubCollectionRef);

    return groupTagsDocData$.pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      map((tagDataListSnap) => {
        return tagDataListSnap.map((tagData) => {
          const id = tagData.id;
          const data: GroupTag = {
            ...tagData.data(),
            id,
            groupId,
          };
          return new GroupTagClass(data);
        });
      })
    );
  }
}
